/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';
import {PermissionsGuard} from '../permissions.guard';
import {FeatureToggleGuard} from '../shared/guards/feature-toggle/feature-toggle.guard';
import {BundlesMainPageComponent} from './bundles-main-page/bundles-main-page.component';
import {Permission} from '../shared/utils/permission.enum';
import {UnsavedChangesGuard} from '../shared/guards/unsaved-work/unsaved-changes.guard';

export const routes: Routes = [
    {
        path: 'bundles',
        canActivate: [FeatureToggleGuard, PermissionsGuard],
        canActivateChild: [FeatureToggleGuard, PermissionsGuard],
        data: {
            hasSideBarMenu: true,
            breadcrumb: 'Bundles',
            permissions: [Permission.ADMIN_BUNDLE_VIEW, Permission.ADMIN_BUNDLES_PERIOD_VIEW, Permission.CUSTOMER_BUNDLES_PERIOD_VIEW],
            featureToggles: ['feature.toggle.bundles'],
            menuItem: {
                label: 'Bundles',
                icon: 'iwp-icon-pluto_group',
                index: 5
            } as RoutingMenuItemModel
        },
        children: [
            {
                path: '',
                component: BundlesMainPageComponent,
                canDeactivate: [UnsavedChangesGuard],
                data: {
                    hasSideBarMenu: true,
                    hasStickyHeader: true,
                    permissions: [
                        Permission.ADMIN_BUNDLE_VIEW,
                        Permission.ADMIN_BUNDLES_PERIOD_VIEW,
                        Permission.CUSTOMER_BUNDLES_PERIOD_VIEW
                    ],
                    menuItem: {
                        label: 'View periods'
                    } as RoutingMenuItemModel
                }
            }
        ]
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BundlesRoutingModule {
}
